// Recibe un token de recovery (en path o hash) y lo verifica contra Supabase Auth.
// Reemplaza el link feo de xsviveqhkppmhncodhuv.supabase.co/auth/v1/verify por uno bonito de panel.limpack.uy
import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export default function Invitar() {
  const { token: tokenParam } = useParams()
  const navigate = useNavigate()
  const [estado, setEstado] = useState('verificando') // verificando | password | guardando | listo | error
  const [error, setError] = useState(null)
  const [password, setPassword] = useState('')
  const [password2, setPassword2] = useState('')
  const [nombreUser, setNombreUser] = useState('')

  useEffect(() => { verificar() }, [])

  async function verificar() {
    try {
      // Token puede venir en URL path /invitar/:token o en hash (#access_token=...)
      let token = tokenParam
      if (!token && window.location.hash) {
        const hash = new URLSearchParams(window.location.hash.replace('#', '?'))
        token = hash.get('access_token') || hash.get('token')
      }
      if (!token) throw new Error('No vino ningún token de invitación.')

      // Verificar OTP de tipo recovery — esto crea sesión y permite cambiar password
      const { data, error: vErr } = await supabase.auth.verifyOtp({
        token_hash: token,
        type: 'recovery',
      })
      if (vErr) throw vErr

      // Cargar nombre desde profile
      const userId = data.user?.id
      if (userId) {
        const { data: prof } = await supabase.from('profiles').select('nombre, role').eq('id', userId).single()
        if (prof?.nombre) setNombreUser(prof.nombre)
      }

      setEstado('password')
    } catch (e) {
      setError(e.message || String(e))
      setEstado('error')
    }
  }

  async function guardarPassword(e) {
    e.preventDefault()
    if (password.length < 8) {
      setError('La contraseña tiene que tener al menos 8 caracteres.')
      return
    }
    if (password !== password2) {
      setError('Las contraseñas no coinciden.')
      return
    }
    setError(null)
    setEstado('guardando')
    try {
      const { error: uErr } = await supabase.auth.updateUser({ password })
      if (uErr) throw uErr
      setEstado('listo')
      // Redirigir según rol
      const { data: { user } } = await supabase.auth.getUser()
      const { data: prof } = await supabase.from('profiles').select('role').eq('id', user.id).single()
      setTimeout(() => {
        if (prof?.role === 'admin') navigate('/admin')
        else if (prof?.role === 'portero') navigate('/portero')
        else if (prof?.role === 'repartidor') navigate('/repartidor/hoy')
        else navigate('/cliente')
      }, 1500)
    } catch (e) {
      setError(e.message || String(e))
      setEstado('password')
    }
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #1A3461 0%, #00A8B5 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 16,
    }}>
      <div style={{
        background: '#F8F6F1', borderRadius: 18, padding: '36px 32px',
        maxWidth: 440, width: '100%',
        boxShadow: '0 24px 64px rgba(0,0,0,.25)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <img src="/isotipo.png" alt="Limpack" style={{ width: 56, height: 56, marginBottom: 12 }} />
          <h1 style={{ fontSize: 24, fontWeight: 900, color: '#1A3461', margin: 0 }}>Bienvenido a Limpack</h1>
        </div>

        {estado === 'verificando' && (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div style={{ fontSize: 14, color: '#475569' }}>Verificando tu invitación…</div>
          </div>
        )}

        {estado === 'password' && (
          <form onSubmit={guardarPassword}>
            <p style={{ fontSize: 14, color: '#475569', marginBottom: 20, textAlign: 'center' }}>
              {nombreUser && <strong style={{ color: '#1A3461' }}>Hola {nombreUser}, </strong>}
              Para terminar tu alta, elegí una contraseña.
            </p>
            <label style={{ display: 'block', marginBottom: 14 }}>
              <span style={{ fontSize: 12, fontWeight: 700, color: '#475569', textTransform: 'uppercase', letterSpacing: '.04em' }}>Contraseña</span>
              <input
                type="password" value={password} onChange={e => setPassword(e.target.value)}
                autoFocus minLength={8} required
                placeholder="Mínimo 8 caracteres"
                style={{ width: '100%', padding: '12px 14px', border: '1px solid #cbd5e1', borderRadius: 10, fontSize: 14, marginTop: 4 }}
              />
            </label>
            <label style={{ display: 'block', marginBottom: 16 }}>
              <span style={{ fontSize: 12, fontWeight: 700, color: '#475569', textTransform: 'uppercase', letterSpacing: '.04em' }}>Repetir</span>
              <input
                type="password" value={password2} onChange={e => setPassword2(e.target.value)}
                minLength={8} required
                placeholder="Repetí la contraseña"
                style={{ width: '100%', padding: '12px 14px', border: '1px solid #cbd5e1', borderRadius: 10, fontSize: 14, marginTop: 4 }}
              />
            </label>
            {error && (
              <div style={{ background: '#FEF2F2', border: '1px solid #FCA5A5', color: '#7F1D1D', padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 12 }}>
                {error}
              </div>
            )}
            <button
              type="submit"
              style={{ width: '100%', background: '#1A3461', color: '#fff', border: 'none', padding: '13px 0', borderRadius: 10, fontWeight: 700, fontSize: 15, cursor: 'pointer' }}
            >Guardar y entrar</button>
          </form>
        )}

        {estado === 'guardando' && (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div style={{ fontSize: 14, color: '#475569' }}>Guardando…</div>
          </div>
        )}

        {estado === 'listo' && (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div style={{ fontSize: 36, marginBottom: 8 }}>✅</div>
            <div style={{ fontSize: 16, fontWeight: 700, color: '#1A3461' }}>¡Listo! Te estamos llevando al panel…</div>
          </div>
        )}

        {estado === 'error' && (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div style={{ fontSize: 36, marginBottom: 8 }}>⚠️</div>
            <div style={{ fontSize: 14, color: '#7F1D1D', marginBottom: 12 }}>
              No se pudo verificar tu invitación: <strong>{error}</strong>
            </div>
            <div style={{ fontSize: 13, color: '#64748b' }}>
              El link puede haber expirado. Pedile a Limpack que te genere uno nuevo.
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
